import { useNavigate, useParams } from '@tanstack/react-router';
import { channelTitle, useChannels } from '../data/channels';
import { useUsers } from '../data/users';
import { useSession } from '../lib/session';
import { openHuddleWindow } from '../lib/huddle-window';
import { Icon } from './Icon';

/**
 * NEM FOGADOTT HIVAS - az egesz app felett, amig el nem olvasod.
 *
 * Eddig csak egy apro ikon jelezte az oldalsavban, es a beszelgetesben egy
 * kartya - aki eppen mashol dolgozott, konnyen elnezte. Egy hivas surgosebb
 * egy uzenetnel: itt marad felul, piros savban, egy kattintasos
 * visszahivassal, amig a beszelgetest meg nem nyitod (akkor magatol eltunik,
 * ugyanugy, mint az oldalsav jelzese).
 */
export function MissedCallBanner() {
  const { data: channels } = useChannels();
  const { usersById, nameDisplay } = useUsers();
  const meId = useSession().data?.user.id ?? '';
  const navigate = useNavigate();
  const { channelId: openChannelId } = useParams({ strict: false }) as { channelId?: string };

  const missed = (channels ?? []).filter(
    (channel) => channel.hasMissedCall && channel.id !== openChannelId,
  );
  if (missed.length === 0) return null;

  const first = missed[0]!;
  const name = channelTitle(first, usersById, meId, nameDisplay);
  const direct = first.kind === 'dm' || first.kind === 'group_dm';
  const rest = missed.length - 1;

  return (
    <div
      role="alert"
      className="flex items-center gap-3 border-b border-alert bg-alert px-4 py-2 text-sm text-white"
    >
      <span
        aria-hidden="true"
        className="grid size-7 shrink-0 animate-pulse place-items-center rounded-full bg-white/20"
      >
        <Icon name="kilepes" />
      </span>
      <p className="min-w-0 flex-1 truncate">
        <strong>Nem fogadott hívás</strong> – {name}
        {rest > 0 && <span className="opacity-85"> és még {rest} beszélgetés</span>}
      </p>
      {direct && (
        <button
          type="button"
          onClick={() => void openHuddleWindow(first.id)}
          className="shrink-0 rounded-pill bg-white px-3 py-1 text-xs font-semibold text-alert transition-opacity hover:opacity-90"
        >
          <Icon name="huddle" size="sm" /> Visszahívás
        </button>
      )}
      <button
        type="button"
        onClick={() => void navigate({ to: '/c/$channelId', params: { channelId: first.id } })}
        className="shrink-0 rounded-pill border border-white/60 px-3 py-1 text-xs font-semibold transition-colors hover:bg-white/15"
      >
        Megnyitás
      </button>
    </div>
  );
}
